import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ORDENESCOMPRAS_APROBACION_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function OrdenesCompraAprobacionPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ORDENESCOMPRAS_APROBACION_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
